
import {Router, ActivatedRoute, Params} from '@angular/router';
import {OnInit, Component} from '@angular/core';
import { serviceURLService } from '../service/serviceURL';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-transaction-response',
  templateUrl: './transaction-response.component.html',
  styleUrls: ['./transaction-response.component.css']
})
export class TransactionResponseComponent implements OnInit {
  transactionId: any;
  downloadPdfLink: any;
  transactionResponse: any;
  transactionSuccessSection: boolean = false;
  transactionFailureSection: boolean = false;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService,private router: Router) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.transactionId = params['secureNowTxnRefNo'];
    });
    this.getTransactionResponse();
  }

  getTransactionResponse(){
    this.serviceURLService.getTransactionResponsonsePA(this.transactionId).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.downloadPdfLink = successData.data.policyDocumentUrl;
      this.transactionResponse = successData.data.isPaymentSuccess;
      if(this.transactionResponse == "SUCCESS"){
        this.transactionSuccessSection = true;
      }else{
        this.transactionFailureSection = true;
      }
    }, errorData => {
      if(errorData.error.status === 401){
        localStorage.clear();
        alert("Login session has been expired..!! Please Login again.")
        this.router.navigate(['login']);
      }
      console.log("Error");
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
